module.exports = {
	"id": "MP",
	"name": "Northern Mariana Islands",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.018579,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.030965,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.024772,
			"30": null,
			"31": 0.284878,
			"32": null,
			"33": null,
			"34": 0.006193,
			"35": null,
			"36": 0.024772,
			"37": 0.12386,
			"38": 0.012386,
			"39": 0.024772,
			"40": 0.030965,
			"41": null,
			"42": 0.161018,
			"43": 0.043351,
			"44": 0.049544,
			"45": 0.235334,
			"46": null,
			"47": 0.037158,
			"48": 0.191983,
			"49": 2.118006,
			"50": 0.117667,
			"51": 0.198176,
			"52": 0.501633,
			"53": 31.609072,
			"54": 6.682247,
			"55": 0.117667,
			"56": 0.024772,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.012386,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.006193,
			"30": null,
			"31": 0.006193,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.012386,
			"37": 0.012386,
			"38": null,
			"39": 0.006193,
			"40": 0.06193,
			"41": null,
			"42": 0.037158,
			"43": 0.043351,
			"44": 0.012386,
			"45": 0.024772,
			"46": 0.024772,
			"47": 0.130053,
			"48": 0.439703,
			"49": 3.821081,
			"50": 0.043351,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.037158
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.049544,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.241527,
			"38": null,
			"39": null,
			"40": 0.216755,
			"41": 0.024772,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0.012386,
			"5": 0.055737,
			"6": null,
			"7": 0.055737,
			"8": 0.222948,
			"9": 0.099088,
			"10": 0.817476,
			"3.1": null,
			"3.2": null,
			"5.1": 0.092895,
			"6.1": 0.018579,
			"7.1": 0.12386,
			"9.1": 0.458282
		},
		"ios_saf": {
			"8": 0,
			"10": 6.33957742881,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.17084427602,
			"8.1-8.4": 0.315627560783,
			"9.0-9.2": 0.150574616153,
			"9.3": 2.29722811823
		},
		"android": {
			"3": 0,
			"4": 0.0534357209302,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00667946511628,
			"4.1": 0.19275027907,
			"4.2-4.3": 0.481875697674,
			"4.4": 1.10497437209,
			"4.4.3-4.4.4": 1.11451646512
		},
		"ie": {
			"6": 0.030965,
			"7": null,
			"8": 0.563563,
			"9": 0.210562,
			"10": 0.117667,
			"11": 4.285556,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0309798132678,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00086055036855
		},
		"edge": {
			"12": 0.055737,
			"13": 0.613107,
			"14": 2.328568
		},
		"ie_mob": {
			"10": 0.0315283943662,
			"11": 0.128365605634
		},
		"bb": {
			"7": 0.00475875,
			"10": null
		},
		"samsung": {
			"0": 5.889429
		},
		"and_uc": {
			"0": 0.654804
		},
		"op_mini": {
			"0": 0.417385636364
		},
		"and_chr": {
			"0": 21.522592
		},
		"and_ff": {
			"0": 0.019035
		}
	},
	"total": 99.02435575
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/MP.json
 ** module id = 593
 ** module chunks = 0
 **/